import * as React from 'react';
import {
  ClickAwayListener,
  ClickAwayListenerProps,
  Fade,
  Popper as MatPopper,
  PopperPlacementType as MatPopperPlacementType,
  SxProps,
  Theme
} from '@mui/material';
import { Paper } from '../Paper';

export interface PopperProps {
  containerRef?: React.RefObject<HTMLDivElement>;
  disablePortal?: boolean;
  handleClickAway: ClickAwayListenerProps['onClickAway'];
  hasTransition?: boolean;
  menu: React.ReactNode;
  menuPaperClassName?: string;
  open: boolean;
  popperAnchorRef: React.RefObject<HTMLElement>;
  popperClassName?: string;
  popperPosition?: MatPopperPlacementType;
  popperRef?: ((instance: HTMLDivElement | null) => void) | React.RefObject<HTMLDivElement>;
  trigger: React.ReactNode;
  sx?: SxProps<Theme>;
  sxPaper?: SxProps<Theme>;
}

const Popper: React.FunctionComponent<PopperProps> = ({
  containerRef,
  disablePortal,
  handleClickAway,
  hasTransition = true,
  menu,
  menuPaperClassName,
  open,
  popperAnchorRef,
  popperClassName,
  popperPosition,
  popperRef,
  trigger,
  sx,
  sxPaper
}) => {
  return (
    <ClickAwayListener onClickAway={event => open && handleClickAway(event)}>
      <div ref={containerRef}>
        {trigger}
        <MatPopper
          ref={popperRef}
          disablePortal={disablePortal}
          open={open}
          anchorEl={popperAnchorRef.current}
          className={popperClassName}
          sx={sx}
          placement={popperPosition}
          transition={hasTransition}
        >
          {hasTransition ? (
            ({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper elevation={2} className={menuPaperClassName} sx={sx}>
                  {menu}
                </Paper>
              </Fade>
            )
          ) : (
            <Paper elevation={2} className={menuPaperClassName} sx={sxPaper}>
              {menu}
            </Paper>
          )}
        </MatPopper>
      </div>
    </ClickAwayListener>
  );
};

Popper.defaultProps = {
  popperPosition: 'bottom-end'
};

Popper.displayName = 'Popper';

export { Popper };
